import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { PlayerProvider } from './context/PlayerContext';
import { LibraryProvider } from './context/LibraryContext';

// Pages
import Home from './pages/Home';
import Library from './pages/Library';
import Playlists from './pages/Playlists';
import PlaylistDetail from './pages/PlaylistDetail';
import Upload from './pages/Upload';
import YouTube from './pages/YouTube';
import DjMixer from './pages/DjMixer';
import NotFound from './pages/NotFound';

// Components
import Layout from './components/Layout';

// Styles
import './styles/App.css';

function App() {
  return (
    <ThemeProvider>
      <LibraryProvider>
        <PlayerProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="library" element={<Library />} />
              <Route path="playlists" element={<Playlists />} />
              <Route path="playlists/:id" element={<PlaylistDetail />} />
              <Route path="upload" element={<Upload />} />
              <Route path="youtube" element={<YouTube />} />
              <Route path="djmixer" element={<DjMixer />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </PlayerProvider>
      </LibraryProvider>
    </ThemeProvider>
  );
}

export default App;
